import React,{useReducer } from 'react'
import Navbar from './Navbar'
import img from "../assets/dashboard-carousel.webp"
import spinner from "../assets/Spinner.webp"
import Tilt from "react-parallax-tilt";
import reducer from '../reducers/reducer';
import { Link } from 'react-router-dom';

const Dashboard = () => {

    return (
        <div id='dashboard'>
            <Navbar />

         <div id='hero'>
         <div id='hero-sec-1'>
               <h1>
               Our <span>Brilliant</span><br/> Idea Can Change Your <span>Brand</span>
               </h1>
                
               <p id='hero-text'>
               Vwrap specializes in creating eye-catching outdoor marketing campaigns that drive engagement and increase brand awareness. With our innovative solutions and unmatched expertise, we can help take your brand to the next level and leave a lasting impression on your target audience.
               </p>

               <div className='btn-container'>
               <p id='hero-btn'><Link to="/contact">Start a Project</Link></p>
               </div>

            </div>
            <div id='hero-sec-2'>
               <span id='spinner'>
               <img id='spinner-img' style={{height:"10rem",width:"10rem"}} src={spinner} alt='vwrap'/>
               </span>
               <Tilt glareEnable={true} tiltMaxAngleX={10} 
        tiltMaxAngleY={10} perspective={1000} 
        glareColor={"rgba(255,0,0,0)"}>
                <img src={img} alt='vwrap'/>
                </Tilt>
            </div>
         </div>
 
           
          
        </div>
    )
}

export default Dashboard
